var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"dense":"","prominent":"","shaped":"","text":"","type":_vm.alertType}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }